import { axiosProtected } from '../../axios-wizard';
import { normalize } from 'normalizr';
import * as schema from '../schema';

// --- Action Types (Beispielhafte Namen) ---
export const UPDATE_PROJECT_OFFER_CALCULATION_DETAILS_START = 'UPDATE_PROJECT_OFFER_CALCULATION_DETAILS_START';
export const UPDATE_PROJECT_OFFER_CALCULATION_DETAILS_SUCCESS = 'UPDATE_PROJECT_OFFER_CALCULATION_DETAILS_SUCCESS';
export const UPDATE_PROJECT_OFFER_CALCULATION_DETAILS_FAILED = 'UPDATE_PROJECT_OFFER_CALCULATION_DETAILS_FAILED';

// --- Action Creators (Beispielhafte Implementierung) ---
const updateProjectOfferCalculationDetailsStart = () => ({
    type: UPDATE_PROJECT_OFFER_CALCULATION_DETAILS_START
});

const updateProjectOfferCalculationDetailsSuccess = (normalizedData) => ({
    type: UPDATE_PROJECT_OFFER_CALCULATION_DETAILS_SUCCESS,
    payload: normalizedData // Enthält die normalisierten Entitäten (z.B. projects)
});

const updateProjectOfferCalculationDetailsFailed = (error) => ({
    type: UPDATE_PROJECT_OFFER_CALCULATION_DETAILS_FAILED,
    payload: error // Optional: Fehlerobjekt übergeben
});


/**
 * Async Action Creator to update the project_offer_calculation_details for a specific project.
 *
 * @param {string|number} projectId - The ID of the project to update.
 * @param {object} calculationDetailsPayload - The data payload containing the calculation details.
 * Expected format: { hourly_rate_in_cents: ..., working_time_in_minutes: ..., site_costs: [...], other_costs: [...] }
 */
export const updateProjectOfferCalculationDetails = (projectId, calculationDetailsPayload) => {
    // Konstruiere die URL basierend auf der Rails-Route
    // Annahme: Die Route ist /api/projects/:projectId/project_offer_calculation_details
    const url = `/api/projects/${projectId}/project_offer_calculation_details`;

    return dispatch => {
        dispatch(updateProjectOfferCalculationDetailsStart());

        // Verwende PUT (oder PATCH), wie es für Update-Aktionen üblich ist
        return axiosProtected.put(url, {
            // Wickel die Payload in den erwarteten Schlüssel ein,
            // wie von `project_offer_calculation_details_params` im Controller gefordert
            project_offer_calculation_details: calculationDetailsPayload
        })
        .then(response => {
            // Der Rails-Controller gibt das gesamte aktualisierte Projekt zurück (`render json: @project`)
            // Normalisiere die Antwort, um den Redux-Store konsistent zu aktualisieren.
            // Annahme: response.data enthält das Projekt-Objekt.
            // Annahme: Du hast ein Schema für ein einzelnes Projekt.
            const normalizedData = normalize(response.data, schema.project); // Verwende dein Projekt-Schema

            // Dispatch der Success-Action mit den normalisierten Daten
            dispatch(updateProjectOfferCalculationDetailsSuccess(normalizedData));

            // Optional: Gib die normalisierten Daten zurück, falls die aufrufende Stelle sie braucht
            return normalizedData;
        })
        .catch(error => {
            console.error("Fehler beim Aktualisieren der Angebotskalkulationsdetails:", error);
            // Dispatch der Failed-Action
            dispatch(updateProjectOfferCalculationDetailsFailed(error));
            // Optional: Wirf den Fehler weiter oder gib ein Fehlerobjekt zurück
            // throw error;
        });
    };
};




// WEBPACK FOOTER //
// ./src/store/actions/projectOfferPositionsDetails.js